import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';

const PortalLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <>
      <Header />
      <div className={`pt-16 flex bg-black text-white min-h-screen transition-all duration-200 ${collapsed ? 'pl-20' : 'pl-56'}`}>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <main className="flex-1 p-6 overflow-hidden">
          <div className="w-full overflow-hidden">
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
};

export default PortalLayout;
